var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1663 6.33366H9.49967C8.65982 6.33366 7.85437 6.66729 7.2605 7.26115C6.66664 7.85502 6.33301 8.66047 6.33301 9.50033V25.3337M6.33301 25.3337V28.5003C6.33301 29.3402 6.66664 30.1456 7.2605 30.7395C7.85437 31.3334 8.65982 31.667 9.49967 31.667H28.4997C29.3395 31.667 30.145 31.3334 30.7388 30.7395C31.3327 30.1456 31.6663 29.3402 31.6663 28.5003V22.167M6.33301 25.3337L13.5942 18.0725C14.188 17.4788 14.9933 17.1453 15.833 17.1453C16.6727 17.1453 17.478 17.4788 18.0718 18.0725L22.1663 22.167M31.6663 15.8337V22.167M31.6663 22.167L29.1552 19.6558C28.5613 19.0622 27.756 18.7287 26.9163 18.7287C26.0767 18.7287 25.2713 19.0622 24.6775 19.6558L22.1663 22.167M22.1663 22.167L25.333 25.3337M28.4997 6.33366H34.833M31.6663 3.16699V9.50033M22.1663 12.667H22.1822",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.260e2fc4e3b6ffa93c959ea34c11908a.svg";
export { ForwardRef as ReactComponent };